import Brand1 from "../../Attachments/Image/Brands/Adidas.png";
import Brand2 from "../../Attachments/Image/Brands/NewHolland.png";
import Brand3 from "../../Attachments/Image/Brands/Nike.png";
import Brand4 from "../../Attachments/Image/Brands/RitterSport.png";

const brandsData = [
  {
    src: Brand1,
    alt: "Adidas Logo",
  },
  { src: Brand2, alt: "New Holland Logo" },
  { src: Brand3, alt: "Nike Logo" },
  { src: Brand4, alt: "Ritter Sport Logo" },
];

export default brandsData;
